import styled from "styled-components";
import { Card, Typography, Box } from "@mui/material";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--mui-palette-background-default);
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 !important;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--mui-palette-divider);
  background-color: var(--mui-palette-background-paper);
  border-radius: 8px 8px 0 0;
  margin-bottom: 0;
`;

export const ContentContainer = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  background-color: var(--mui-palette-background-paper);
  border-radius: 0 0 8px 8px;
  box-shadow: var(--mui-shadows-2);

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const ModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: var(--mui-palette-background-paper);
  box-shadow: var(--mui-shadows-8);
  padding: 24px;
  border-radius: 12px;
`;

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: var(--mui-palette-text-primary);
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

// export const AddButton = styled(Button)`
//   margin-bottom: 20px;
// `;

export const DashboardContainer = styled.div`
  height: calc(100vh - 115px);
  background: #fff;
  overflow-y: auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const Title = styled(Typography)`
  color: var(--mui-palette-text-primary);
  margin: 0;
`;

export const StyledCard = styled(Card)`
  background: var(--mui-palette-background-paper);
  color: var(--mui-palette-text-primary);
  border: 1px solid var(--mui-palette-divider);
  transition: all 0.3s ease;
  height: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: none !important;
  &:hover {
    transform: translateY(-4px);
  }
`;

export const CardHeader = styled.div`
  padding: 16px;
  background: var(--mui-palette-background-default);
  border-bottom: 1px solid var(--mui-palette-divider);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StatusBadge = styled.span`
  background: var(--mui-palette-primary-main);
  color: var(--mui-palette-primary-contrastText);
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s ease;
  &:hover {
    background: var(--mui-palette-primary-dark);
  }
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: var(--mui-palette-background-default);
  border-radius: 8px;
  margin: 8px 0;
  border: 1px solid var(--mui-palette-divider);
  transition: all 0.2s ease;

  &:hover {
    background: var(--mui-palette-action-hover);
    transform: translateX(4px);
  }
`;

export const IconWrapper = styled.div`
  color: var(--mui-palette-primary-main);
`;

export const InfoText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--mui-palette-text-secondary);
`;

export const ValueText = styled.span`
  color: var(--mui-palette-text-primary);
  font-weight: 600;
`;

export const TopBtnBox = styled.div`
  display: flex;
  gap: 0.5rem;
`;
export const CardContent = styled.div`
  padding: 16px;
`;

export const LoadInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: var(--mui-palette-background-default);
  border-radius: 8px;
  border: 1px solid var(--mui-palette-divider);
  transition: all 0.2s ease;

  &:hover {
    background: var(--mui-palette-action-hover);
  }
`;

export const LoadLabel = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--mui-palette-text-secondary);
`;

export const LoadValue = styled(Typography)`
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--mui-palette-primary-main);
`;
